import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';

import Header from '@/components/Header';
import Newsletter from '../../components/_common/Newsletter';
import MetaDetail from '../../components/_common/MetaDetail';
import tracking from '../../utils/tracking';
import './home-delivery.scss';
import Slider from '../../components/_common/Slider';

class HomeDeliveryPage extends Component {
	constructor(props) {
		super(props);
		this.getNewsletter();
	}

	async getNewsletter() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

		await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/NEWSLETTER OVERLAY.json?v=${Math.random()}`)
			.then(response => {
				this.setState({ newsletterData: response.data.contents });
			});
	}

	componentDidMount() {
		tracking.pageView('/home-delivery');
	}

	render() {
		const title = this.state.title;
		const subhead = this.state.subhead;
		const welcomeItems = this.state.items;
		const newsletter = this.state.newsletterData;
		let newsletterContent = [];
		let signUpFormData = {};
		let signUpFormContents = {};

		const meta = {
			title: 'Home Delivery',
			description: 'At the Guinness Open Gate Brewery, our brewers are given the creative license to dream in beer. Inspiring experimentations have led to some exciting creations including Hop House 13. The experimental brewery dates back over 100 years, and now for the first time ever we’re offering delivery – direct from our home to yours! Our food menu boasts bold flavours to complement our beers. Try exclusive small batch brews, most of which are limited editions.',
			canonical: window.location.href
		};

		if (welcomeItems) {
			items = welcomeItems.map(item => this.Item(item));
		}

		if (newsletter != undefined) {
			for (let i = 0; i < newsletter.length; i++) {
				let fieldsObj = {};
				let contentKey = '';
				for (let field of newsletter[i].fields) {
					if (field.id === 'module') {
						switch (field.value) {
							case ('Sign up - overlay screen 1'):
								contentKey = 'Screen1';
								break;
							case ('Form field 1 - YOUR EMAIL'):
								contentKey = 'Field1';
								break;
							case ('Sign up - overlay screen 2'):
								contentKey = 'Screen2';
								break;
							case ('Sign up - already subscribed'):
								contentKey = 'Screen3';
								break;
							default:
								('Unknown Key');
								break;
						}
						continue;
					}
					else if (field.id === 'modules-details') {
						for (let newsField of field.fields) {
							let fieldKey = newsField.title;
							let fieldVal = newsField;
							fieldsObj[fieldKey] = fieldVal;
						}
						continue;
					}
				}
				if (contentKey === 'Screen1') {
					newsletterContent.push(fieldsObj);
				}

				signUpFormContents[contentKey] = [];
				signUpFormContents[contentKey].push(fieldsObj);
			}

			signUpFormData.contents = signUpFormContents;
		}

		if (!signUpFormData) return null;
		signUpFormData.fetchedData = signUpFormData.built = true;

		let items = [
			{
				header: 'ORDER NOW',
				copy: 'For the first time ever, we’re giving you the chance to try these experimental brews outside the brewery. Check out our range of limited-edition beers delivered fresh from our home to yours.',
				color: 'blue',
				button: 'https://www.just-eat.ie/',
				buttonText: 'ORDER NOW'
			},
			{
				header: 'Beer',
				html: ['Enjoy our seasonal beer and food pairings in the comfort of your own home. Pair one of our latest innovations with a dish that’s been carefully crafted by our chefs to perfectly complement the beer. Choose from mouth-watering', <a href="https://www.instagram.com/griolladh/" target="_blank" style={{ color: 'white' }} rel="noreferrer"> Griolladh</a>, ' toasties paired with a Hop House 13, or our legendary ‘Spice Bag’ Hot Wings paired with one of our latest experiments, the Sea Salt & Lime Lager.'],
				color: 'red',
				button: 'https://www.just-eat.ie/',
				buttonText: 'OUR MENU'
			}
		
			
		];

		return (
			<div className="welcome" >
				<Header />
				<div className="welcome-page">
					<MetaDetail meta={meta} />
					<div className={'hero hero--active'}>
						<div className={'feature feature--active'}>
							<div className={'hero__container'}>
								<div className={'hero__background'} />
								<div className={'hero__heading-container'}>
									<div className={'hero__text-container'}>
										<p className={'hero__subhead'}>
										At the Guinness Open Gate Brewery, our brewers are given the creative license to dream in beer. Inspiring experimentations have led to some exciting creations including Hop House 13. The experimental brewery dates back over 100 years, and now for the first time ever we’re offering delivery – direct from our home to yours! Our food menu boasts bold flavours to complement our beers. Try exclusive small batch brews, most of which are limited editions.
										
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="hero--waves" />
					</div>
					{items && items.map((item, i) => (
						<div className={'feature feature--active welcome__container'}>
							<div className={`welcome-item__wrap ${i % 2 === 0 ? 'image-right' : 'image-left'} welcome-item__bg--${item.color}`}>
								<div className={'welcome-item__text-container'}>
									<h2 className={'welcome-item__name'}>{item.header}</h2>
									<div className={'welcome-item__separator'} />
									{item.html &&
											
											item.html.map((item) => (item))
											
									}
									{item.copy &&
											<div className={'welcome-item__desc'} dangerouslySetInnerHTML={{ __html: item.copy }} />
									}
										
									{item.button && <div className="contact-us-button"><a style={{ color: 'black' }} href={item.button} target="_blank" rel="noreferrer">{item.buttonText}</a></div> }
								</div>
								{/* <div className={'welcome-item__image-container'} style={`background-image: url('${item.img}'); background-position: center; background-repeat: no-repeat; background-size: cover`} /> */}
							</div>
						</div>

					))
					}
					
					<div className={'feature feature-flex feature--active welcome__container'}>

						<div className={`feature-half welcome-item__wrap welcome-item__bg--blue`}>
							<div className={'welcome-item__text-container'}>
								<h2 className={'welcome-item__name'}>OPENING HOURS</h2>
								<div className={'welcome-item__separator'} />
								<div className={'welcome-item__desc'}  />
								<ul style="list-style-type:none;">
									<li>Wednesday – Friday 5pm – 9pm</li>
									<li>Saturday - Sunday 1pm – 9pm</li>
								</ul>
											
							</div>
						</div>
						
						
						<div className={`feature-half welcome-item__wrap welcome-item__bg--blue`}>
							<div className={' welcome-item__text-container'}>
								<h2 className={'welcome-item__name'}>Contact Us</h2>
								<div className={'welcome-item__separator'} />
								<div className={'welcome-item__desc'}  />
								<ul style="list-style-type:none;">
									<li><a
										href="info@guinnessopengate.com"
										target="_blank"
									    > info@guinnessopengate.com </a></li>
									<li>+353 1 471 2455. Lines open Mon-Fri, 9am-5pm</li>
								</ul>
											
							</div>
						</div>
					</div>
					
					<Slider />
					
				</div>
			</div >
		);
	}
}

// 	export default connect(
//   () => ({}),
// 	{buildContentAction}
// ) (WelcomePage);
export default HomeDeliveryPage;



// WEBPACK FOOTER //
// ./src/pages/home-delivery/index.js